<template>
  <div class="option-panel-show"  v-loading="loading">

    <div class="option-panel-group-box flex">
      <gj-card
          :padding="'19px 0 19px 16px'"
          :title="getTitle(item)"
          :number="getNum(item)"
          v-for="(item, index) in data" :key="index"
      >
        <template #info>
          <div class="total-panel--title">
            <span class="total-panel--day-label">{{'环比    :'}}</span>
            <ChainRatio :percent="parseInt(item.percent)"/>
          </div>
        </template>
      </gj-card>
    </div>

<!--    <el-row>-->
<!--      <el-col class="option-panel-show-col" v-for="(item,index) in data" :key="index">-->
<!--        <div class="total-panel&#45;&#45;report"-->
<!--             :class="{'active': type === 'sales'}"-->
<!--             @click="selectChart('sales', '销售额')">-->
<!--          <div class="total-panel&#45;&#45;title">{{ item.label }}</div>-->
<!--          <div class="total-panel&#45;&#45;summary">-->
<!--            <div v-if="item.prefix === 'currencySymbol'">-->
<!--              {{ item.currencySymbol }}{{ item.value | amount | defaultShow }}-->
<!--            </div>-->
<!--            <div v-else>-->
<!--              {{ item.value || 0 }}{{ item.suffix }}-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="total-panel&#45;&#45;summary">-->
<!--            <span class="total-panel&#45;&#45;day-label">环比  ：</span>-->
<!--            <ChainRatio :percent="parseInt(item.percent)"/>-->
<!--          </div>-->
<!--        </div>-->
<!--      </el-col>-->
<!--    </el-row>-->
  </div>
</template>

<script>
import ChainRatio from "@/views/components/chain-ratio/chain-ratio"
import {amount, amountSymbol} from "@/filters";

export default {
  name: "option-panel-show",
  props:{
    data:{
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  components:{ ChainRatio },
  data(){
    return {
      type: '',
    }
  },
  methods: {
    getTitle(item){
      let str='-';
      if(item.label){
        str = item.label
      }
      if(item.prefix === 'currencySymbol'&&item.currencySymbol){
        str+='('+item.currencySymbol+')'
      }
      return str
    },
    getNum(item){
      if(item.prefix === 'currencySymbol'){
        return amountSymbol(item.value || 0,2)
        // return (item.currencySymbol||'')+ amount(item.value || 0)
      }else {
        return (item.value || 0) + (item.suffix || '')
      }
    },
    selectChart(type, typeName) {

    }
  }
}
</script>

<style scoped lang="scss">

.option-panel-group-box{
  justify-content: space-between;
  margin-bottom: 8px;
  .gj-card{
    flex: 1;
  }
  .gj-card+.gj-card{
    margin-left: 8px;
  }

  .total-panel--title {
    color: #999999;
    display: flex;
    align-items: center;
    //justify-content: space-between;

    &:nth-of-type(1) div {
      background: red;
    }

    &:nth-of-type(2) div {
      background: yellow;
    }


    &__tag {
      display: inline-block;
      width: 6px;
      height: 13px;
      border-radius: 3px;
      margin-left: 5px;
    }
  }

  .total-panel--title:last-child {
    margin-bottom: 0;
  }
  .total-panel--day-label {
    font-size: 12px;
    margin-right: 41px;
  }
}

.option-panel-show{

}
.option-panel-show-col {
  width: 14.28%;
  box-sizing: border-box;
  margin-bottom: 10px;
}

.total-panel--content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 0;
  background: #FAFAFA;
  border-radius: 4px;
}

.total-panel--title {
  margin-bottom: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #999999;
}

.total-panel--summary {
  margin-bottom: 4px;
  font-size: 20px;
}
.total-panel--report {
  cursor: pointer;
  text-align: center;
  /*border: 1px solid #e8e8e8;*/
  border-radius: 4px;
  padding: 10px;
}
.total-panel--day-number {
  font-size: 12px;
}
.total-panel--day-label {
  font-size: 12px;
}

/*.total-panel--report:hover {*/
/*  border-color: #1F6EEF;*/
/*}*/

.total-panel--report.active {
  border-color: #1F6EEF;
}
.down-icon {
  color: #F56C6C;
}
.up-icon {
  color: #19BE6B;
}
</style>